import DatatableHeader from "./datatable-header.container";

export default DatatableHeader;
